<template>
  <div class="layout mod-simple">
    <toolbar v-if="isLoggedIn" @logout="$parent.logout" />

    <div class="row main-row">
      <div class="col-md-12 page-content">
        <div class="page-wrapper">
          <router-view/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import toolbar from '@components/common/Toolbar';

export default {
  components: {
    toolbar
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn
    }
  },
  data() {
    return {
    }
  },
  mounted() {

  },
  methods: {
  }
}
</script>
